module.exports = __webpack_public_path__ + "img/logohome1.f2abd398.png";